import { c as _c } from "react/compiler-runtime";
import { Children } from 'react';
import type { CSSProperties, HTMLElementType, PropsWithChildren } from 'react';
import invariant from 'tiny-invariant';
import styles from './index.module.scss';
export const enum AspectRatioValues {
  RATIO_16_9 = 16 / 9,
  RATIO_16_4 = 16 / 4,
}
type Props = {
  as?: HTMLElementType;
  ratio?: AspectRatioValues;
  className?: string;
  style?: CSSProperties;
};

/**
 * The `<AspectRatio />` component does some CSS magic to make elements adhere to a 16:9 or 16:4 ratio.
 * It will wrap a wrapper element (`<div />` by default) and injects needed styles into the child.
 */
export function AspectRatio(t0) {
  const $ = _c(5);
  const {
    as: t1,
    className,
    style,
    children,
    ratio: t2
  } = t0;
  const As = t1 === undefined ? "div" : t1;
  const ratio = t2 === undefined ? AspectRatioValues.RATIO_16_9 : t2;
  invariant(Children.count(children) === 1, "<AspectRatio /> can only have one direct child.");
  const t3 = `${styles.wrapper} ${ratio === AspectRatioValues.RATIO_16_9 ? styles.aspect169 : styles.aspect164} ${className ? className : ""}`;
  let t4;
  if ($[0] !== As || $[1] !== children || $[2] !== style || $[3] !== t3) {
    t4 = <As className={t3} style={style}>{children}</As>;
    $[0] = As;
    $[1] = children;
    $[2] = style;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}